import { useDispatch, useMessageStore, useRootStore } from "@/stores/RootStoreContext";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { ReportsView } from "./reportsComponents";
import { initReportsResultPage } from "./reportsDomain";

export const ReportsResultPage = observer(() => {
  const { portfolioReports, companyFieldDetails, queryParams } = useRootStore();
  const dispatch = useDispatch();
  const alertStore = useMessageStore();

  useEffect(() => {
    dispatch(initReportsResultPage(queryParams));
  }, [dispatch, queryParams]);

  return (
    <ReportsView
      state={portfolioReports}
      fieldDetails={companyFieldDetails}
      alertStore={alertStore}
    />
  );
});
